import {Store} from '@reatom/core'
import {createPrimitiveAtom} from '@reatom/core/primitives'
import {getTime, hoursToMilliseconds} from 'date-fns'
import {indexBy} from 'ramda'
import {getApi} from '../../api'

let lastInitTimestamp: number | null

export interface BoxNumberData {
  id: string
  title: string
  color: string
}

export const boxNumberDataAtom = createPrimitiveAtom<
  Record<string, BoxNumberData>
  >({})

export async function updateBoxNumberAtom({dispatch}: Store) {
  if (
    lastInitTimestamp &&
    lastInitTimestamp + hoursToMilliseconds(2) > getTime(new Date())
  ) {
    return
  }
  const data = await getApi().provider.getBoxNumberMap()
  const record = indexBy(x => x.id, data)
  dispatch(boxNumberDataAtom.set(record))
  lastInitTimestamp = getTime(new Date())
  return record
}